<template>
  <div class="error_body">
    <div class="cons error_401">
      <p class="txt">抱歉，您没有权限访问，请联系管理员</p>
      <div class="btn_box">
		  <span class="btn" @click.stop="goHome">返回首页</span>
      </div>
    </div>
  </div>
</template>
<script>
import 'assets/stylus/error.styl';
export default{
	methods:{
		goHome(){
			this.$router.push({'name':"home"})
		}
	}
}
</script>
<style scoped>
.txt{
  position: absolute;top:240px;left:640px;right:10px;
  text-align: center;
}
.btn_box{
  position:absolute;left:640px;right:10px;top:300px;
  text-align:center;
}
.btn_box .btn{display:inline-block;padding:10px 30px;color:#FFFFFF;}
</style>
